module.exports = __webpack_public_path__ + "img/xiaozi_huice.fb17f038.png";